import React from 'react';

import InputField from '../inputField/InputField';
import MultiSelectDropdown, {
    type DropdownOptionType
} from '../multiSelectDropdown/MultiSelectDropdown';
import { useTranslation } from 'react-i18next';
import { type User } from '../../api/types/index';

type PlaylistFormProps = {
    user: User;
    title: string;
    moduleTypeOptions: DropdownOptionType[];
    selectedModuleTypes: DropdownOptionType[];
    onModuleTypeSelection: (selectedOptions: DropdownOptionType[]) => void;
    onTitleChange: (value: string) => void;
};

const PlaylistForm = ({
    title,
    moduleTypeOptions,
    selectedModuleTypes,
    onModuleTypeSelection,
    onTitleChange
}: PlaylistFormProps) => {
    const { t } = useTranslation();
    return (
        <div className="playlist-form-container">
            <InputField
                isFocusDisabled
                label={t('new_playlist_title_field')}
                name="playlist-name"
                onValueChangeHandler={onTitleChange}
                value={title}
            />
            <MultiSelectDropdown
                options={moduleTypeOptions}
                label={t('playlist_module')}
                name="playlist-module"
                onChange={onModuleTypeSelection}
                defaultValue={selectedModuleTypes}
                isFilterable
                hint={
                    selectedModuleTypes.length === 0
                        ? t('edit_playlist_module_type_hint')
                        : undefined
                }
            />
        </div>
    );
};

export default PlaylistForm;
